import { render, staticRenderFns } from "./ContestRulesContent.vue?vue&type=template&id=622ccc79&scoped=true&"
import script from "./ContestRulesContent.vue?vue&type=script&lang=js&"
export * from "./ContestRulesContent.vue?vue&type=script&lang=js&"
import style0 from "./ContestRulesContent.vue?vue&type=style&index=0&id=622ccc79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622ccc79",
  null
  
)

export default component.exports